import { Buffer } from "buffer";
export { RailtownRequest } from "./request";
export { normalizeStackFrame, getNativeErrorFromStackTrace, getStackTrace, getStackFrames, } from "./stack-trace";
/**
 *
 * @param {string} errorMessage The error message to check
 * @param {(string | RegExp)[]} ignoreErrors The list of errors to ignore
 * @returns {boolean} Whether the error should be ignored
 */
export function shouldIgnoreError(errorMessage, ignoreErrors) {
    for (const ignore of ignoreErrors) {
        if (ignore instanceof RegExp) {
            if (ignore.test(errorMessage)) {
                return true;
            }
        }
        else if (errorMessage.includes(ignore)) {
            return true;
        }
    }
    return false;
}
/**
 *
 * @param {string} text The text to escape
 * @returns {string} The escaped text
 */
export function escapeSpecialChars(text) {
    return text
        .replace(/\r?\n|\r/g, "\\n")
        .replace(/\\'/g, "\\'")
        .replace(/\\"/g, '\\"')
        .replace(/\\&/g, "\\&")
        .replace(/\\t/g, "\\t")
        .replace(/\\b/g, "\\b")
        .replace(/\\f/g, "\\f");
}
/**
 *
 * @param {object} json JSON object to escape
 * @returns {string | boolean} The escaped JSON string or false if unable to escape
 */
export function escape(json) {
    try {
        const bodyString = JSON.stringify(json);
        const escapedBody = escapeSpecialChars(bodyString);
        return escapedBody;
    }
    catch (_unused) {
        console.warn("Unable to create request obj");
        return "";
    }
}
/**
 *
 * @param {string} type The type of log level including debug, info, warn, error
 * @returns {number} The log level
 */
export function getLogLevel(type) {
    switch (type) {
        case "debug":
            return 1;
        case "info":
            return 2;
        case "silly":
            return 2;
        case "warn":
            return 3;
        case "error":
            return 4;
        default:
            return 4;
    }
}
/**
 * _uuid
 *
 * Legacy UUID generator from Vanilla JS
 *
 * @returns {string} A UUID
 */
export function _uuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0, v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Get Browser Name
 *
 * Legacy function to get the browser name
 *
 */
export function getBrowserName() {
    const userAgent = navigator.userAgent;
    let browserName;
    if (userAgent.match(/edg/i)) {
        browserName = "Edge";
    }
    else if (userAgent.match(/firefox|fxios/i)) {
        browserName = "Firefox";
    }
    else if (userAgent.match(/opr\//i)) {
        browserName = "Opera";
        // @ts-expect-error Brave browser sets brave property on window.navigator
    }
    else if (window.navigator.brave?.isBrave?.name == "isBrave") {
        browserName = "Brave";
    }
    else if (userAgent.match(/chrome|chromium|crios/i)) {
        browserName = "Chrome";
    }
    else if (userAgent.match(/safari/i)) {
        browserName = "Safari";
        // @ts-expect-error IE has document.documentMode
    }
    else if ( /*@cc_on!@*/false || !!document.documentMode) {
        browserName = "IE";
    }
    else {
        browserName = "Unknown";
    }
    return browserName;
}
/**
 * List of keys from the User Properties object to be removed before sending logs
 */
export const userPropertiesExcludedKeys = ["ignoreErrors"];
export const excludeReservedKeysFromUserProperties = (userProperties) => {
    const filteredUserProperties = {};
    for (const key in userProperties) {
        if (!userPropertiesExcludedKeys.includes(key)) {
            filteredUserProperties[key] = userProperties[key];
        }
    }
    return filteredUserProperties;
};
export const sendError = async (level, args) => {
    try {
        const parsedData = JSON.parse(args);
        const base64ParseToken = Buffer.from(parsedData?.key, "base64").toString("utf-8");
        const jsonParseToken = JSON.parse(base64ParseToken);
        const url = "https://" + jsonParseToken.u;
        const body = {
            Message: parsedData?.error?.message,
            Level: getLogLevel(level),
            OrganizationId: jsonParseToken.o,
            ProjectId: jsonParseToken.p,
            EnvironmentId: jsonParseToken.e,
            Caller: "",
            Runtime: parsedData?.runtime || "v8-javascript",
            Exception: parsedData?.error?.stack,
            TimeStamp: new Date().toISOString(),
            Properties: parsedData?.error?.properties,
        };
        const gRequest = [
            {
                Body: escape(body),
                UserProperties: {
                    AuthenticationCode: jsonParseToken.h,
                    ClientVersion: "REST.v1",
                    Encoding: "utf-8",
                    ConnectionName: jsonParseToken.u,
                },
            },
        ];
        await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(gRequest),
        });
    }
    catch (e) {
        console.warn("Error sending error log", e);
    }
};
//# sourceMappingURL=index.js.map